import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";





import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";

import MembersGroupFormSelect from "../../../../auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect";

import { PrimaryRole } from "../../../../auth/types/models/Role";

import RoleFormSelect from "../../../../auth/components/role/RoleForm/RoleFormSelect";

import { PrimaryScopeGroup } from "../../../../auth/types/models/ScopeGroup";

import ScopeGroupFormSelect from "../../../../auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect";






import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";


















export const initialFormStateFn = () => { return {
    
        
        membersGroupId: null,
        
    
        
        roleId: null,
        
    
        
        scopeGroupId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.membersGroupId = PrimaryMembersGroup.fromQuery(location.state?.membersGroupId) || null;
    initialFormState.roleId = PrimaryRole.fromQuery(location.state?.roleId) || null;
    initialFormState.scopeGroupId = PrimaryScopeGroup.fromQuery(location.state?.scopeGroupId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        membersGroupId:
        string()
                .nanoid(msg`Member Group is required`)
                .min(1, msg`Member Group is required`),
    
    
        roleId:
        string()
                .nanoid(msg`Role is required`)
                .min(1, msg`Role is required`),
    
    
        scopeGroupId:
        string()
                .nanoid(msg`Scope Group is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const RoleAssignmentAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <MembersGroupFormSelect
        type="dynamicSelect"
        name="membersGroupId"
        label={t`Member Group`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <RoleFormSelect
        type="select"
        name="roleId"
        label={t`Role`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ScopeGroupFormSelect
        type="dynamicSelect"
        name="scopeGroupId"
        label={t`Scope Group`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default RoleAssignmentAddForm;
